import {CalendarAction, CalendarActionsEnum, CalendarState} from "./types";

const initialState: CalendarState = {
    events: [],
    isLoading: false
}

export default function (state = initialState, action: CalendarAction): CalendarState {
    switch (action.type) {
        case CalendarActionsEnum.SET_EVENTS:
            return {...state, events: action.payload}
        case CalendarActionsEnum.SET_IS_LOADING:
            return {...state, isLoading: action.payload}
        case CalendarActionsEnum.SET_NEAREST_TOURNAMENT:
            return {...state, nearestTournament: action.payload}
        default:
            return state
    }
}
